import React from 'react';

const DocumentViewer = ({ document }) => {
  if (!document) {
    return <div className="empty-state">Select a document to view.</div>;
  }

  return (
    <div className="document-viewer">
      <div className="comparison-header">
        <div>
          <h3>{document.filename || `Document ${document.id}`}</h3>
          <p className="muted">
            {document.document_type?.replace('_', ' ')} | Views: {document.view_count || 0}
          </p>
        </div>
      </div>
      <div className="document-content-view">{document.content_text || 'No content available.'}</div>
    </div>
  );
};

export default DocumentViewer;
